/*
 * @ngdoc directive
 * @name plumFeature
 * @restrict EA
 * @multiElement
 * @param {string} featureName is the name of the key you want to look
 * for in the JSON file returned from the API
 * @param {function} featureCallback is a callback that is called on the
 * data returned by the API
 * @example
 <plum-feature feature-name="subscription" feature-callback="">
   <div ng-if="dataFeature">
     Show me if subscription is true
   </div>
 </plum-feature>
*/
export default plumFeature

/** @ngInject */
function plumFeature(featuresService) {
    return ({
        restrict: 'E',
        scope: {
            featureCallback: '=',
            featureName: '@',
        },
        template: '<span ng-transclude></span>',
        transclude: true,
        link(scope, element, attrs, ctrl, transclude) {
            const callback = function (features) {
                scope.$parent.dataFeature = scope.$parent.dataFeature || []
                scope.$parent.dataFeature[scope.featureName] = features[scope.featureName]
                if (scope.featureCallback !== undefined) {
                    return scope.featureCallback(scope.$parent, features[scope.featureName])
                }
            }

            return featuresService.getFeatures(callback)
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/plum-feature/directive.js